export default {
  cn: {
    userDatum: {
      crumbs: {
        newaAccount: "用户开户",
        amend: "用户修改",
      },
      sales: {
        title: '账号资料',
        form: {
          sales_id: "账号",
          acc_name: '账户名称',
          acc_type: "账户类型",
          phone:'手机号',
          email:'邮箱',
          remark:'备注',
          code: "代码",
          last_code: "上级代码",
          password: '密码'
        }
      },
      sales_info: {
        title: '个人资料',
        form: {
          birth_date: "出生日期",
          jurisdiction: {
            name: "权限级别",
            genderArr: ['客服', '管理员']
          },
          gender: {
            name: '性别',
            genderArr: ['请选择', '先生', '女士']
          },
          country: {
            name: '国家/地区',
            countryArr: ['请选择', '中国', '香港特别行政区', '台湾', '阿富汗', '阿尔巴尼亚', '亚尔及利亚', '萨摩亚', '安道尔', '安哥拉', '安圭拉', '南极', '安提瓜和巴布达', '阿根廷', '亚美尼亚', '阿鲁巴', '澳洲', '维也纳', '阿塞拜疆', '巴哈马', '巴林', '孟加拉共和国', '巴巴多斯', '白俄逻斯', '比利时', '伯利兹', '贝宁', '百慕达', '不丹', '玻利维亚', '波斯尼亚', '博茨瓦纳', '波维特岛', '巴西', '英属印度洋领域', '英国公民', '英国属土公民', '英国国民海外', '英国海外公民', '受英国保护人士', '英籍人士', '文莱', '保加利亚', '布基纳法索', '布基纳法索', '缅甸', '蒲隆地', '柬埔寨', '喀麦隆', '加拿大', '佛得角', '开曼群岛', '中非共和国', '乍得', '智利', '圣诞岛', '科科斯群岛', '哥伦比亚', '科摩逻', '刚果', '库克群岛', '哥斯达尼加', '科特迪瓦', '克逻地亚', '古巴', '塞浦路斯', '捷克', '丹麦', '吉布提', '多明尼加共和国', '多米尼克', '东帝汶', '厄瓜多尔', '埃及', '西班牙', '萨尔瓦多', '赤道几内亚', '厄立特里亚', '爱沙尼亚', '埃塞俄比亚', '福克兰群岛', '法逻群岛', '斐济', '芬兰', '法国', '法国大都会', '法属圭亚那', '玻里尼西亚', '法国南方属地', '加彭', '冈比亚', '甘比亚', '格鲁吉亚', '德国', '迦纳', '直布逻陀', '希蜡', '格陵兰', '格林纳达', '关岛', '危地马拉', '几内亚', '几内亚比绍', '圭亚那', '海地', '赫德及麦当奴群岛', '洪都拉斯', '匈牙利', '冰岛', '印度', '印度尼西亚', '伊朗', '伊拉克', '爱尔兰', '以色列', '意大利', '牙买加', '日本', '约旦', '哈萨克斯坦', '肯尼亚', '基里巴斯', '韩国', '科威特', '吉尔吉斯坦', '老挝寮国', '拉脱维亚', '黎巴嫩', '莱索托', '利比里亚', '阿拉伯利比亚民众国', '列支敦士登', '立陶宛', '卢森堡', '澳门特别行政区', '前南斯拉夫马其顿共和国', '马达加斯加', '马拉维', '马来西亚', '马尔代夫', '马里', '马耳他', '马绍尔群岛', '马提尼克岛', '毛里塔尼亚', '毛里求斯', '马约特岛', '墨西哥', '密克逻尼西亚联邦', '摩尔多瓦', '摩纳哥', '蒙古', '蒙特内哥逻', '蒙特塞拉特', '摩洛哥', '莫桑比克', '缅甸', '纳米比亚', '瑙鲁', '尼泊尔', '荷属安的列斯群岛', '荷兰', '新喀里多尼亚', '新西兰', '尼加拉瓜', '尼日尔', '尼日利亚', '纽埃', '诺福克岛', '朝鲜', '北马里亚纳群岛', '挪威', '巴勒斯坦佔领区', '阿曼', '巴基斯坦', '帕劳', '巴拿马', '巴布亚新几内亚', '巴拉圭', '秘鲁', '菲律宾', '皮特凯恩', '波兰', '葡萄牙', '波多黎各', '卡塔尔', '难民', '其他难民', '留尼汪岛', '逻马尼亚', '俄逻斯联邦', '卢旺达', '圣卢西亚', '萨摩亚', '圣马利诺', '圣多美和普林西比', '沙特阿拉伯', '塞内加尔', '塞尔维亚', '塞舌尔', '塞拉利昂', '新加坡', '斯洛伐克共和国', '斯洛文尼亚', '所逻门群岛', '索马里', '斯里兰卡', '圣赫勒拿', '基茨-尼维斯', '圣皮埃尔岛及密克隆岛', '圣文森特和格林纳丁斯', '无国籍人士', '苏丹', '苏里南', '斯瓦巴及尖绵', '斯威士兰', '瑞典', '瑞士', '叙利亚', '塔吉克斯坦', '坦桑尼亚', '泰国', '多哥', '托克劳群岛', '东加', '特立尼达和多巴哥', '突尼斯', '土耳其', '土库曼斯坦', '特克斯和凯科斯群岛', '图瓦卢', '美国米诺群岛', '乌干达', '乌克兰', '阿拉伯联合酋长国', '联合国办事署', '联合国组织', '美利坚合众国美国', '乌拉圭', '乌兹别克斯坦', '瓦努阿图', '梵蒂冈', '委内瑞拉', '越南', '英属处女群岛', '美属处女群岛', '瓦利斯和富图纳群岛', '萨摩亚西', '也门', '也门共和国', '南非', '扎伊尔', '赞比亚', '津巴布韦']
          },
          addr: "地址",
          phone: "电话",
          email: "邮箱",
          lang: {
            name: '语言',
            langArr: ['请选择', '简体中文', '繁体中文', '英文'],
          },
          doc_type: {
            name: '证件类型',
            docTypeArr: ['请选择', '身份证', '驾驶证', '护照']
          },
          docNo: '证件号码',
          docFrontImg: '证件附件(正面)',
          docBackImg: '证件附件(反面)',
          localCcy: '当地货币',
          bankCardType: '银行卡类型',
          bankCardNo: '银行卡号',
          beneficiaryName: '受益人',
          bank: {
            name: '银行',
            bankArr: ['请选择', '中国工商银行', '中国农业银行', '中国建设银行', '招商银行', '中信银行', '交通银行', '广东发展银行', '上海浦东发展银行', '中国银行', '城市商业银行', '中国农业发展银行', '光大银行', '华夏银行', '中国民生银行', '深圳发展银行', '兴业银行', '恒丰银行', '浙商银行', '农村合作银行', '农村商业银行', '农村信用合作社', '城市信用合作社', '徽商银行', '渤海银行', '中国邮政储蓄银行', '北京银行', '平安银行股份有限公司', '南京银行', '江苏银行', '宁波银行', '上海银行', '杭州银行', '东亚银行', '青岛银行', '广州银行', '其他']
          },
          swiftCode: '银行代码',
          bankAddr: '开户行地址',
          bankCardImg: '银行卡图片',
          remark: '备注'
        }
      },
      submit: "注册",
      changeBtn: '保存修改',
      flaseTipNum:'请输入11位以内数字',
      flaseTipName: '请输入您的账户名称',
      flaseTipPass:'请输入您的密码',
      flasePhone:'请输入您的手机号',
      flaseTip: '请正确输入',
      loginTip: '账号或密码有误',
      fileUpload: '选择文件上传',
      repeatId: '该账号已被注册',
      TipPassWord: '密码已进行隐藏处理，如需修改请直接填写',
      logOut: {
        word: "是否退出登录?",
        yes: '确定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        err: "请正确填写信息",
      },
      user_id_point: '该账号已经存在',
      user_name_point: '该账户名称已经存在',
      email_isRepeat: '邮箱已被注册，请重新输入'
    }
  },
  hk: {
    userDatum: {
      crumbs: {
        newaAccount: "用戶開戶",
        amend: "用戶修改",
      },
      sales: {
        title: '帳號資料',
        form: {
          sales_id: "帳號",
          acc_name: '帳戶名稱',
          acc_type: "帳戶類型",
          code: "代碼",
           phone:'手機號',
          email:'郵箱',
          remark:'備注',
          last_code: "上級代碼",
          password: '密碼'
        }
      },
      sales_info: {
        title: '個人資料',
        form: {
          birth_date: "出生日期",
          jurisdiction: {
            name: "許可權級別",
            genderArr: ['客服', '管理員']
          },
          gender: {
            name: '性別',
            genderArr: ['', '先生', '女士']
          },
          country: {
            name: '國家/地區',
            countryArr: ['', '中國', '香港特別行政區', '臺灣', '阿富汗', '阿爾巴尼亞', '亞爾及利亞', '薩摩亞', '安道爾', '安哥拉', '安圭拉', '南極', '安地卡及巴布達', '阿根廷', '亞美尼亞', '阿魯巴', '澳洲', '維也納', '亞塞拜然', '巴哈馬', '巴林', '孟加拉共和國', '巴貝多', '白俄邏斯', '比利時', '貝里斯', '貝南', '百慕達', '不丹', '玻利維亞', '波士尼亞', '波札那', '波維特島', '巴西', '英屬印度洋領域', '英國公民', '英國屬土公民', '英國國民海外', '英國海外公民', '受英國保護人士', '英籍人士', '汶萊', '保加利亞', '布吉納法索', '布吉納法索', '緬甸', '蒲隆地', '柬埔寨', '喀麥隆', '加拿大', '維德角', '開曼群島', '中非共和國', '查德', '智利', '聖誕島', '科科斯群島', '哥倫比亞', '科摩邏', '剛果', '科克群島', '哥斯達尼加', '象牙海岸', '克邏地亞', '古巴', '賽普勒斯', '捷克', '丹麥', '吉布地', '多明尼加共和國', '多明尼克', '東帝汶', '厄瓜多爾', '埃及', '西班牙', '薩爾瓦多', '赤道幾內亞', '厄立特里亞', '愛沙尼亞', '衣索比亞', '福克蘭群島', '法邏群島', '斐濟', '芬蘭', '法國', '法國大都會', '法屬圭亞那', '玻裡尼西亞', '法國南方屬地', '加彭', '甘比亞', '甘比亞', '格魯吉亞', '德國', '迦納', '直布邏陀', '希蠟', '格陵蘭', '格瑞那達', '關島', '瓜地馬拉', '幾內亞', '幾內亞比索', '圭亞那', '海地', '赫德及麥當奴群島', '洪都拉斯', '匈牙利', '冰島', '印度', '印尼', '伊朗', '伊拉克', '愛爾蘭', '以色列', '義大利', '牙買加', '日本', '約旦', '哈薩克', '肯亞', '吉里巴斯', '韓國', '科威特', '吉爾吉斯坦', '老撾寮國', '拉脫維亞', '黎巴嫩', '賴索托', '賴比瑞亞', '阿拉伯利比亞民眾國', '列支敦士登', '立陶宛', '盧森堡', '澳門特別行政區', '前南斯拉夫馬其頓共和國', '馬達加斯加', '馬拉威', '馬來西亞', '馬爾地夫', '馬里', '馬爾他', '馬紹爾群島', '馬提尼克島', '茅利塔尼亞', '模里西斯', '馬約特', '墨西哥', '密克邏尼西亞聯邦', '莫爾達瓦', '摩納哥', '蒙古', '蒙特內哥邏', '蒙瑟拉特島', '摩洛哥', '莫三比克', '緬甸', '納米比亞', '諾魯', '尼泊爾', '荷屬安的列斯群島', '荷蘭', '新赫里多尼亞', '紐西蘭', '尼加拉瓜', '尼日爾', '奈及利亞', '紐埃', '諾福克島', '朝鮮', '北馬里安納群島', '挪威', '巴勒斯坦佔領區', '阿曼', '巴基斯坦', '帛琉', '巴拿馬', '巴布亞紐幾內亞', '巴拉圭', '秘魯', '菲律賓', '皮特凱恩', '波蘭', '葡萄牙', '波多黎各', '卡達', '難民', '其他難民', '留尼旺島', '邏馬尼亞', '俄邏斯聯邦', '盧旺達', '聖露西亞', '薩摩亞', '聖馬利諾', '聖多美及普林西比島', '沙烏地阿拉伯', '塞內加爾', '塞爾維亞', '塞席爾', '獅子山', '新加坡', '斯洛伐克共和國', '斯洛維尼亞', '所邏門群島', '索馬里', '斯里蘭卡', '聖赫勒拿', '基茨-尼維斯', '聖皮爾島及密克隆島', '聖文森特和格林納丁斯群島', '無國籍人士', '蘇丹', '蘇利南', '斯瓦巴及尖綿', '史瓦濟蘭', '瑞典', '瑞士', '敘利亞', '塔吉克斯坦', '坦桑尼亞', '泰國', '多哥', '托克勞群島', '東加', '千里達和多巴哥', '突尼斯', '土耳其', '土庫曼斯坦', '特克斯和凱科斯群島', '吐瓦魯', '美國米諾群島', '烏干達', '烏克蘭', '阿拉伯聯合大公國', '聯合國辦事署', '聯合國組織', '美利堅合眾國美國', '烏拉圭', '烏茲別克斯坦', '瓦努阿圖', '梵蒂岡', '委內瑞拉', '越南', '英屬處女群島', '美屬處女群島', '瓦利斯和富圖納群島', '薩摩亞西', '葉門', '葉門共和國', '南非', '薩伊', '尚比亞', '辛巴威']
          },
          addr: "地址",
          phone: "電話",
          email: "郵箱",
          lang: {
            name: '語言',
            langArr: ['', '簡體中文', '繁體中文', '英文'],
          },
          doc_type: {
            name: '證件類型',
            docTypeArr: ['', '身份證', '駕駛證', '護照']
          },
          docNo: '證件號碼',
          docFrontImg: '證件附件(正面)',
          docBackImg: '證件附件(反面)',
          localCcy: '當地貨幣',
          bankCardType: '銀行卡類型',
          bankCardNo: '銀行卡號',
          beneficiaryName: '受益人',
          bank: {
            name: '銀行',
            bankArr: ['', '中國工商銀行', '中國農業銀行', '中國建設銀行', '招商銀行', '中信銀行', '交通銀行', '廣東發展銀行', '上海浦東發展銀行', '中國銀行', '城市商業銀行', '中國農業發展銀行', '光大銀行', '華夏銀行', '中國民生銀行', '深圳發展銀行', '興業銀行', '恒豐銀行', '浙商銀行', '農村合作銀行', '農村商業銀行', '農村信用合作社', '城市信用合作社', '徽商銀行', '渤海銀行', '中國郵政儲蓄銀行', '北京銀行', '平安銀行股份有限公司', '南京銀行', '江蘇銀行', '寧波銀行', '上海銀行', '杭州銀行', '東亞銀行', '青島銀行', '廣州銀行', '其他']
          },
          swiftCode: '銀行代碼',
          bankAddr: '開戶行地址',
          bankCardImg: '銀行卡圖片',
          remark: '備註'
        }
      },
      submit: "註冊",
      changeBtn: '保存修改',
      flaseTipNum:'請輸入11位以內數字',
      flaseTipName: '請輸入您的賬戶名稱',
      flaseTipPass:'請輸入您的密碼',
      flasePhone:'請輸入您的手機號',
      flaseTip: '請正確輸入',
      loginTip: '帳號或密碼有誤',
      fileUpload: '選擇檔上傳',
      repeatId: '該帳號已被注册',
      TipPassWord: '密碼已進行隱藏處理，如需修改請直接填寫',
      logOut: {
        word: '是否登出?',
        yes: '確定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        err: "請正確填寫資訊",
      },
      user_id_point: '該賬號已經存在',
      user_name_point: '該帳戶名稱已經存在',
      email_isRepeat: '郵箱已被註冊，請重新輸入'
    }
  },
  en: {
    userDatum: {
      crumbs: {
        newaAccount: "Create a user account",
        amend: "Create a user account",
      },
      sales: {
        title: 'Account Information',
        form: {
          sales_id: "User ID",
          acc_name: 'User Name',
          acc_type: "Account Type",
          code: "Code",
           phone:'Phone',
          email:'Email',
          remark:'Remark',
          last_code: "Superior Code",
          password: 'Password'
        }
      },
      sales_info: {
        title: 'Personal Information',
        form: {
          birth_date: "Birth Date",
          jurisdiction: {
            name: "Profile Setting",
            genderArr: ['service', 'Administrator']
          },
          gender: {
            name: 'Gender',
            genderArr: ['', 'Male', 'Female']
          },
          country: {
            name: 'Country',
            countryArr: ['', 'CHN China', 'HKG Hong Kong S.A.R.', 'TWN Taiwan', 'AFG Afghanistan', 'ALB Albania', 'DZA Algeria', 'ASM Samoa', 'And Andorra', 'AGO Angola', 'AIA Anguilla', 'ATA Antarctica', 'ATG Antigua and Barbuda', 'ARG Argentina', 'ARM Armenia', 'ABW Aruba', 'AUS Australia', 'AUT Vienna', 'AZE Azerbaijan', 'BHS Bahamas', 'BHR Bahrain', 'BGD Bangladesh', 'BRB Barbados', 'BLR Belarus', 'BEL Belgium', 'BLZ Belize', 'Ben Benin', 'BMU Bermuda', 'BTN Bhutan', 'Bol Bolivia', 'BIH Bosnia', 'BWA Botswana', 'BVT Povet', 'BRA Brazil', 'IOT British Indian Ocean Area', 'GBR British citizenship', 'GBD British Dependent Territories Citizens', 'GBN British National Overseas', 'GBO British Overseas Citizen', 'GBP protected by the British,', 'GBS British', 'BRN Brunei', 'BGR Bulgaria', 'BFA Burkina Faso', 'HVO Burkina Faso', 'BUR Burma', 'BDI Burundi', 'KHM Cambodia', 'CMR Cameroon', 'CAN Canada', 'CPV Cape Verde', 'CYM Cayman Islands', 'CAF Central African Republic', 'TCD Chad', 'CHL Chile', 'CXR Christmas Island', 'CCK Cocos Islands', 'COL Colombia', 'COM Como', 'COG Congo', 'COK Cook Islands', 'CRI Costa Rica', "CIV Côte d'Ivoire", 'HRV Kolodia', 'CUB Cuba', 'CYP Cyprus', 'CZE Czech', 'DNK Denmark', 'DJI Djibouti', 'Dom Dominican Republic', 'DMA Dominica', 'TLS East Timor', 'ECU Ecuador', 'EGY Egypt', 'ESP Spain', 'SLV Salvador', 'GNQ Equatorial Guinea', 'ERI Eritrea', 'Est Estonia', 'ETH Ethiopia', 'FLK Falkland Islands', 'FRO Lego Islands', 'FJI Fiji', 'FIN Finland', 'FRA France', 'FXX Metropolis of France', 'GUF French Guiana', 'PYF Polynesia', 'ATF South of France', 'GAB Gabon', 'GLP Gambia', 'GMB Gambia', 'GEO Georgia', 'DEU Germany', 'GHA Ghana', 'GIB Direct', 'GRC Greek wax', 'GRL Greenland', 'GRD Grenada', 'GUM Guam', 'GTM Guatemala', 'GIN Guinea', 'GNB-Bissau', 'GUY Guyana', 'HTI Haiti', 'HMD Hurd and McDonald Islands', 'HND Honduras', 'HUN Hungary', 'ISL Iceland', 'IND India', 'IDN Indonesia', 'IRN Iran', 'IRQ Iraq', 'IRL Ireland', 'ISR Israel', 'ITA Italy', 'JAM Jamaica', 'JPN Japan', 'JOR Jordan', 'KAZ Kazakhstan', 'Ken Kenya', 'KIR Kiribati', 'KOR Korea', 'KWT Kuwait', 'KGZ Kyrgyzstan', 'LAO Laos Laos', 'LVA Latvia', 'LBN Lebanon', 'LSO Lesotho', 'LBR Liberia', 'LBY Libyan Arab Jamahiriya', 'LIE Liechtenstein', 'LTU Lithuania', 'LUX Luxembourg', 'MAC Macao Special Administrative Region', 'MKD Former Yugoslav Republic of Macedonia', 'MDG Madagascar', 'MWI Malawi', 'MYS Malaysia', 'MDV Maldives', 'MLI Mali', 'MLT Malta', 'MHL Marshall Islands', 'MTQ Martinique', 'MRT Mauritania', 'MUS Mauritius', 'MYT Mayotte', 'MEX Mexico', 'FSM Federated States of Micronesia', 'MDA Moldova', 'MCO Monaco', 'MNG Mongolia', 'MNE Montenegro', 'MSR Montserrat', 'MAR Morocco', 'MOZ Mozambique', 'MMR Burma', 'Nam Namibia', 'NRU Nauru', 'NPL Nepal', 'ANT Netherlands Antilles', 'NLD Netherlands', 'NCL New Caledonia', 'NZL New Zealand', 'NIC Nicaragua', 'NER Niger', 'NGA Nigeria', 'NIU Niue', 'NFK Norfolk Island', 'PRK North Korea', 'MNP Northern Mariana Islands', 'NOR NORWAY', 'PSE Occupied Palestinian Territory', 'OMN Oman', 'PAK PAKISTAN', 'PLW Palau', 'Pan Panama', 'PNG Papua New Guinea', 'PRY Paraguay', 'PER Peru', 'PHL Philippines', 'PCN Pitcairn', 'POL Poland', 'PRT Portugal', 'PRI Puerto Rico', 'QAT Qatar,', 'XXB Refugee', 'XXC other refugees', 'REU Reunion Island', 'ROU Romanian', 'RUS Russian Federation', 'RWA Rwanda', 'LCA Saint Lucia', 'WSM Samoa', 'SMR San Marino', 'STP Sao Tome and Principe', 'SAU Saudi Arabia', 'SEN Senegal', 'SRB Serbia', 'SYC Seychelles', 'SLE Sierra', 'SGP Singapore', 'SVK the Slovak Republic', 'SVN Slovenia', 'SLB Solomon Islands', 'SOM Somalia', 'LKA Sri Lanka', 'SHN St. Helena', 'KNA Kitts-Nevis', 'SPM Saint Pierre and Miquelon', 'VCT Saint Vincent and the Grenadines', 'XXA stateless person', 'SDN Sudan', 'SUR Suriname', 'SJM Swabian and Spike', 'SWZ Swaziland', 'SWE Sweden', 'CHE Switzerland', 'SYR Syria', 'TJK Tajikistan', 'TZA Tanzania', 'THA Thailand', 'TGO Togo', 'TKL Tokelau', 'TON Plus', 'TTO Trinidad and Tobago', 'TUN Tunisia', 'TUR Turkey', 'TKM Turkmenistan', 'TCA Turks and Caicos Islands', 'TUV Tuvalu', 'UMI American Mino', 'UGA Uganda', 'UKR Ukraine', 'ARE United Arab Emirates', 'UNA United Nations Office', 'UNO United Nations Organization', 'USA United States of America USA', 'URY Uruguay', 'UZB Uzbekistan', 'VUT Vanuatu', 'VAT Vatican', 'VEN Venezuela', 'VNM Vietnam', 'VGB British Virgin Islands', 'VIR American Virgin Islands', 'WLF Wallis and Futuna Islands', 'ESH Samoa West', 'YMD Yemen', 'YEM Republic of Yemen', 'ZAF South Africa', 'ZAR Zaire', 'ZMB Zambia', 'ZWE Zimbabwe']
          },
          addr: "Address",
          phone: "Phone:",
          email: "Email",
          lang: {
            name: 'Email Language',
            langArr: ['', 'CHS Simplified Chinese', 'CHT Traditional Chinese', 'ENG English'],
          },
          doc_type: {
            name: 'Document Type',
            docTypeArr: ['', 'IDC Identity Card', 'DRI Driver License', 'POT Passport']
          },
          docNo: 'Id Number',
          docFrontImg: 'Id Front Img',
          docBackImg: 'Id back Img',
          localCcy: 'Local Currency',
          bankCardType: 'Bank Card Type',
          bankCardNo: 'Bank Card Number',
          beneficiaryName: 'Beneficiary Name',
          bank: {
            name: 'Bank',
            bankArr: ['', 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA', 'AGRICULTURAL BANK OF CHINA', 'CHINA CONSTRUCTION BANK CORPORATION', 'CHINA MERCHANTS BANK', 'CITIC BANK CORPORATION LIMITED', 'BANK OF COMMUNICATIONS', 'CHINA GUANGFA BANK', 'SHANGHAI PUDONG DEVELOPMENT BANK', 'BANK OF CHINA LIMITED', 'CITY COMMERCIAL BANKS', 'AGRICULTURAL DEVELOPMENT BANK OF CHINA', 'CHINA EVERBRIGHT BANK', 'HUA XIA BANK', 'CHINA MINSHENG BANKING CORPORATION, LIMITED', 'SHENZHEN DEVELOPMENT BANK CO., LTD', 'INDUSTRIAL BANK', 'EVERGROWING BANK', 'CHINA ZHESHANG BANK', 'RURAL COOPERATION BANK', 'RURAL COMMERCIAL BANK', 'RURAL CREDIT COOPERATIVES UNION', 'CITY CREDIT COOPERATIVES UNION', 'HUISHANG BANK', 'CHINA BOHAI BANK', 'POSTAL SAVINGS BANK OF CHINA', 'BANK OF BEIJING', 'PING AN BANK', 'BANK OF NANJING', 'BANK OF JIANGSU', 'BANK OF NINGBO', 'BANK OF SHANGHAI', 'BANK OF HANGZHOU CO., LTD', 'THE BANK OF EAST ASIA LIMITED', 'BANK OF QINGDAO', 'BANK OF GUANGZHOU', 'OTHER']
          },
          swiftCode: 'Swift Code',
          bankAddr: 'Bank Address',
          bankCardImg: 'Bank Card Img',
          remark: 'Remark'
        }
      },
      submit: "Submit",
      changeBtn: 'Save Modify',
      flaseTipNum:'Please input 11 digits or less',
      flasePhone:'Please input your mobile phone number',
      flaseTipName: 'Please enter your account name',
      flaseTipPass:'Please enter your password',
      flaseTip: 'Please input correctly',
      loginTip: 'The account or password is incorrect',
      fileUpload: 'Select upload file',
      repeatId: 'this account has been registered',
      TipPassWord: 'If you need to change it, please fill it out directly',
      logOut: {
        word: 'Do you want to logout?',
        yes: 'Sure',
        no: 'Cancel'
      },
       submitResult: {
        succeed: "save successfully",
        err: "Please fill in the information correctly",
      },
      user_id_point: 'The account already exists',
      user_name_point: 'The account name already exists',
      email_isRepeat: 'Email has been registered, please re-enter'
    }
  }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/userDatum.js